module.exports = __webpack_public_path__ + "static/media/bars.c5f08bbb.svg";